import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 导入样式
import '@/styles/index.less'
import { address } from '@/api/index.js'
import axios from 'axios'
import VueResource from 'vue-resource'
import { Toast,Popup  } from 'vant';
import 'vant/lib/index.css';
Vue.use(Toast);
Vue.use(Popup);
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.prototype.$address = address
// 设置一个vue的原型$http=axios,就可以在其他vue文件里直接this.$http使用axios了
// Vue.prototype.$http = axios
axios.defaults.withCredentials = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
